module.exports = __webpack_public_path__ + "img/ocean-hotel-7.67496234.jpg";